/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  DestroyDocumentFolderResponseData,
  DestroyDocumentFolderResponseDataFromJSON,
  DestroyDocumentFolderResponseDataFromJSONTyped,
  DestroyDocumentFolderResponseDataToJSON
} from './DestroyDocumentFolderResponseData'

/**
 *
 * @export
 * @interface DestroyDocumentFolderResponse
 */
export interface DestroyDocumentFolderResponse {
  /**
   *
   * @type {number}
   * @memberof DestroyDocumentFolderResponse
   */
  status?: number
  /**
   *
   * @type {DestroyDocumentFolderResponseData}
   * @memberof DestroyDocumentFolderResponse
   */
  data?: DestroyDocumentFolderResponseData
}

export function DestroyDocumentFolderResponseFromJSON(json: any): DestroyDocumentFolderResponse {
  return DestroyDocumentFolderResponseFromJSONTyped(json, false)
}

export function DestroyDocumentFolderResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DestroyDocumentFolderResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : DestroyDocumentFolderResponseDataFromJSON(json['data'])
  }
}

export function DestroyDocumentFolderResponseToJSON(value?: DestroyDocumentFolderResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: DestroyDocumentFolderResponseDataToJSON(value.data)
  }
}
